// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditIfrPlan } from '../../forms/FormEditIfrPlan/FormEditIfrPlan';

// props
export interface DialogEditIfrPlanProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditIfrPlan = ({ isOpen, onClose, onSuccess }: DialogEditIfrPlanProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('savePlan'),
					form: 'form-edit-ifr-plan',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('renamePlan'),
				variant: 'h3',
			}}>
			<FormEditIfrPlan onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
